// extracted by mini-css-extract-plugin
export default {"box":"Card_box__FAAS0","zoom":"Card_zoom__3Uz2H"};